import { CardInfo } from "../IllustCard/IllustCard";
import "./IllustCardBig.scoped.scss";

type Props = CardInfo;

// 1枚分のメッセージカードを表現するコンポーネント
export default function IllustCardBig(props: Props) {
  const src = `${process.env.PUBLIC_URL}/img/illusts/${props.src}`;
  return (
    <div className={`card_type${props.backgroundType}`}>
      <div className="illust">
        <img
          src={src}
          alt={`Illustration by ${props.name} (@${props.twitterID})`}
        ></img>
      </div>
      <div className="author">
        <div className="author-center">
          {props.name}
          <br />
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://twitter.com/${props.twitterID}`}
            className="App-link"
          >
            {`@${props.twitterID}`}
          </a>
        </div>
      </div>
    </div>
  );
}
